import { render, staticRenderFns } from "./VideoSdk.vue?vue&type=template&id=32944618&"
import script from "./VideoSdk.vue?vue&type=script&lang=js&"
export * from "./VideoSdk.vue?vue&type=script&lang=js&"
import style0 from "./VideoSdk.vue?vue&type=style&index=0&id=32944618&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports